import React from 'react';

import LightWindow from '../../components/LightWindow';
import H2 from '../../styled-components/H2';
import Description from '../../styled-components/Description';
import GalleryImage from '../../styled-components/GalleryImage';

import GalleryItemWrapper from '../../styled-components/GalleryItemWrapper';
import GalleryDescription from '../../styled-components/GalleryDescription';

class GalleryItem extends React.Component {
  render() {
    return (
      <GalleryItemWrapper style={{backgroundImage: 'url(' + this.props.bg + ')'}}>
        <GalleryDescription onClick={this.props.showModal}>
          <H2 light>{this.props.title}</H2>
        </GalleryDescription>
      </GalleryItemWrapper>
    )
  }
}

export default GalleryItem;



// WEBPACK FOOTER //
// ./src/components/GalleryItem/index.js